"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyService = void 0;
const loyalty_1 = require("../models/loyalty");
const api_1 = require("./api");
const PATH = '/loyalty/api';
const PATH_V1 = '/loyalty/api/v1';
const PATH_V2 = '/loyalty/api/v2';
const expandUserPoints = (payload) => {
    if (!payload) {
        return null;
    }
    const { id, activities, redeemable_points: redeemablePoints, total_points: totalPoints } = payload;
    return { id, activities, redeemablePoints, totalPoints };
};
class LoyaltyService {
    static async getUserPoints() {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/user/points`
            });
            return expandUserPoints(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserRewards() {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/user/rewards`
            });
            return loyalty_1.Reward.JsonToRewards(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserActivities(page, size) {
        let requestParams = ``;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        if (size) {
            requestParams = `size=${size}&` + requestParams;
        }
        try {
            const response = await api_1.API.get({
                url: `${PATH}/activity/user?${requestParams}`
            });
            return loyalty_1.Activity.JsonToActivities(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getActivities() {
        try {
            const response = await api_1.API.get({
                url: `${PATH_V1}/activities`
            });
            return loyalty_1.Activity.JsonToActivities(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getRewardCategories() {
        try {
            return await api_1.API.get({
                url: `${PATH}/reward/categories`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getCampaign(activityId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/activity/campaign?activity_id=${activityId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async postUserCodeCampaign(codeSubmit, campaignId, campaignGroupId) {
        try {
            if (!campaignId && !campaignGroupId)
                return new Error('Invalid Code Submission');
            return await api_1.API.post({
                url: `${PATH}/user/code/submit`,
                body: { campaignId, campaignGroupId, codeValue: codeSubmit }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async creditUserPoints(activityId) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/activities/credit`,
                body: { activityId }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async creditUserPointsV1(activityId, headers) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/activities/credit`,
                body: { activityId },
                headers: Object.assign({}, headers)
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getRewards() {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/rewards?activeOnly=1`
            });
            return loyalty_1.Reward.JsonToRewards(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getAllRewards() {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/rewards`
            });
            return loyalty_1.Reward.JsonToRewards(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getReward(rewardId) {
        try {
            return await api_1.API.get({ url: `${PATH}/rewards/${rewardId}` });
        }
        catch (e) {
            throw e;
        }
    }
    static async redeemReward(rewardId, quantity) {
        try {
            return await api_1.API.post({
                url: `${PATH}/user/rewards/redeem`,
                body: { rewardId, quantity }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async redeemRewardFromLoyalty(rewardId, quantity) {
        try {
            return await api_1.API.post({
                url: `${PATH}/user/rewards/redeem`,
                body: { rewardId, quantity }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getSurvey(activityId) {
        try {
            const survey = await api_1.API.get({
                url: `${PATH}/activity/survey?activity_id=${activityId}`
            });
            const surveyPostResponse = {
                surveyId: survey.id,
                responses: survey.questions.map(question => ({
                    id: question.id,
                    value: null
                }))
            };
            return { survey, surveyPostResponse };
        }
        catch (e) {
            throw e;
        }
    }
    static async getSurveyResponse(activityId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/activity/survey/result?survey_id=${activityId}`
            });
            const userResponses = response && response[0] ? response[0].survey_responses : [];
            return userResponses;
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchRewardEntryDetails(id) {
        const url = `${PATH}/user/reward/entries/${id}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async postSurvey(surveyPostResponse) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/survey`,
                body: surveyPostResponse
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async postSurveyV1(surveyPostResponse) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/survey`,
                body: surveyPostResponse
            });
        }
        catch (e) {
            throw e;
        }
    }
    static uploadPhoto(activityId, { file }, cancelToken, onUploadProgress, onSuccess, onError) {
        const body = new FormData();
        body.append('activityId', activityId);
        body.append('multipartFile', file);
        const source = api_1.API.createCancelToken();
        api_1.API.post({
            url: `${PATH}/activity/user/upload-photo`,
            contentType: 'multipart/form-data',
            body,
            onUploadProgress,
            cancelToken: source.token
        })
            .then(response => {
            onSuccess(response);
        })
            .catch(error => {
            onError(error);
        });
        cancelToken.cancel = source.cancel;
    }
    static async getActivity(activityId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/user/activity/${activityId}`
            });
            return loyalty_1.Activity.JsonToActivity(response);
        }
        catch (e) {
            throw e;
        }
    }
    static async getActivityByKey(activityKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/activity/by-key/${activityKey}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getUserActivityByKey(activityKey) {
        try {
            return await api_1.API.get({
                url: `${PATH}/user/activity/by-key/${activityKey}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getActivityMappings() {
        try {
            return await api_1.API.get({
                url: `${PATH}/activity/mappings`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getActivityMapping(key) {
        try {
            return await api_1.API.get({
                url: `${PATH}/activity/mappings/${key}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getPoll(activityId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/poll/${activityId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async submitPoll(pollResponse, activityId) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/poll`,
                body: {
                    pollResponse,
                    pollId: activityId
                }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getQuiz(activityId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/quiz/${activityId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async submitQuiz(quizResponse, activityId) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/quiz`,
                body: {
                    quiz_response: quizResponse,
                    quizId: activityId
                }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getSurveyV2(activityId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/survey/${activityId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getSurveyResultV2(activityId) {
        try {
            return await api_1.API.get({
                url: `${PATH_V2}/survey/${activityId}/result`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async submitSurveyV2(body) {
        try {
            return await api_1.API.post({
                url: `${PATH_V2}/survey`,
                body
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.LoyaltyService = LoyaltyService;
//# sourceMappingURL=loyalty-service.js.map